import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traditional Chinese (fallback) namespaces
import commonZHTW from './locales/zh-TW/common.json';
import homeZHTW from './locales/zh-TW/home.json';
import experiencesZHTW from './locales/zh-TW/experiences.json';
import propertiesZHTW from './locales/zh-TW/properties.json';
import packagesZHTW from './locales/zh-TW/packages.json';
import planZHTW from './locales/zh-TW/plan.json';
import referralZHTW from './locales/zh-TW/referral.json';
import orderZHTW from './locales/zh-TW/order.json';
import authZHTW from './locales/zh-TW/auth.json';
import guideZHTW from './locales/zh-TW/guide.json';
import adminZHTW from './locales/zh-TW/admin.json';

// Simplified Chinese namespaces
import commonZHCN from './locales/zh-CN/common.json';
import homeZHCN from './locales/zh-CN/home.json';
import experiencesZHCN from './locales/zh-CN/experiences.json';
import propertiesZHCN from './locales/zh-CN/properties.json';
import packagesZHCN from './locales/zh-CN/packages.json';
import planZHCN from './locales/zh-CN/plan.json';
import referralZHCN from './locales/zh-CN/referral.json';
import orderZHCN from './locales/zh-CN/order.json';
import authZHCN from './locales/zh-CN/auth.json';
import guideZHCN from './locales/zh-CN/guide.json';
import adminZHCN from './locales/zh-CN/admin.json';

// English namespaces
import commonEN from './locales/en/common.json';
import homeEN from './locales/en/home.json';
import experiencesEN from './locales/en/experiences.json';
import propertiesEN from './locales/en/properties.json';
import packagesEN from './locales/en/packages.json';
import planEN from './locales/en/plan.json';
import referralEN from './locales/en/referral.json';
import orderEN from './locales/en/order.json';
import authEN from './locales/en/auth.json';
import guideEN from './locales/en/guide.json';
import adminEN from './locales/en/admin.json';

const resources = {
  'zh-TW': {
    common: commonZHTW,
    home: homeZHTW,
    experiences: experiencesZHTW,
    properties: propertiesZHTW,
    packages: packagesZHTW,
    plan: planZHTW,
    referral: referralZHTW,
    order: orderZHTW,
    auth: authZHTW,
    guide: guideZHTW,
    admin: adminZHTW,
  },
  'zh-CN': {
    common: commonZHCN,
    home: homeZHCN,
    experiences: experiencesZHCN,
    properties: propertiesZHCN,
    packages: packagesZHCN,
    plan: planZHCN,
    referral: referralZHCN,
    order: orderZHCN,
    auth: authZHCN,
    guide: guideZHCN,
    admin: adminZHCN,
  },
  en: {
    common: commonEN,
    home: homeEN,
    experiences: experiencesEN,
    properties: propertiesEN,
    packages: packagesEN,
    plan: planEN,
    referral: referralEN,
    order: orderEN,
    auth: authEN,
    guide: guideEN,
    admin: adminEN,
  },
};

const namespaces = [
  'common',
  'home',
  'experiences',
  'properties',
  'packages',
  'plan',
  'referral',
  'order',
  'auth',
  'guide',
  'admin',
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-TW',
    supportedLngs: ['zh-TW', 'zh-CN', 'en'],
    ns: namespaces as unknown as string[],
    defaultNS: 'common',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
